import { mainCategoryResultSchema } from "@/schema/console/evaluation-reports/MainCategoryResult";
import { sdgGoalResultSchema } from "@/schema/console/evaluation-reports/SdgGoalResult";
import { z } from "zod";

export const resultIndexSchema = z.object({
  id: z.number(),
  score: z.number().nullable(),
  sdg_score: z.number().nullable(),
  main_category_results: z.array(mainCategoryResultSchema),
  sdg_goal_results: z.array(sdgGoalResultSchema),
});

export type ResultIndex = z.infer<typeof resultIndexSchema>;
